import { render, staticRenderFns } from "./tButton.vue?vue&type=template&id=ef491fa8"
import script from "./tButton.vue?vue&type=script&lang=ts"
export * from "./tButton.vue?vue&type=script&lang=ts"
import style0 from "./tButton.vue?vue&type=style&index=0&id=ef491fa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports